/* eslint-disable */
"use strict";
exports.__esModule = true;
exports.chartjsPluginProvideGroup = void 0;
var ChartGroupProvider = /** @class */ (function () {
    function ChartGroupProvider(key, chart) {
        var _a;
        if (ChartGroupProvider.groupsStore.has(key))
            (_a = ChartGroupProvider.groupsStore.get(key)) === null || _a === void 0 ? void 0 : _a.push(chart);
        else
            ChartGroupProvider.groupsStore.set(key, [chart]);
        this.groupKey = key;
        this.chart = chart;
    }
    Object.defineProperty(ChartGroupProvider.prototype, "charts", {
        get: function () {
            return ChartGroupProvider.groupsStore.get(this.groupKey);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChartGroupProvider.prototype, "otherCharts", {
        get: function () {
            var _this = this;
            return this.charts.filter(function (chart) { return chart !== _this.chart; });
        },
        enumerable: false,
        configurable: true
    });
    ChartGroupProvider.prototype.stop = function () {
        this.charts.splice(this.charts.indexOf(this.chart), 1);
        if (this.charts.length === 0)
            ChartGroupProvider.groupsStore["delete"](this.groupKey);
    };
    ChartGroupProvider.groupsStore = new Map();
    return ChartGroupProvider;
}());
// chart.js плагин
exports.chartjsPluginProvideGroup = {
    id: 'provideGroup',
    start: function (chart, _, _a) {
        var groupKey = _a.groupKey, chartKey = _a.chartKey;
        chart.group = new ChartGroupProvider(groupKey, chart);
        chart.chartKey = chartKey;
    },
    stop: function (chart) {
        var _a;
        (_a = chart.group) === null || _a === void 0 ? void 0 : _a.stop();
    }
};
